{
  "longPressMessage": "Dugo pritisnite ili pritisnite Alt + strelicu prema dole da otvorite meni"
}
